import { render, staticRenderFns } from "./ImageUpload.vue?vue&type=template&id=21657ea6&lang=pug&"
import script from "./ImageUpload.ts?vue&type=script&lang=ts&"
export * from "./ImageUpload.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports